@import '../../globals/variables';

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$file-upload-default-radius: 4px !default;
$file-upload-dropzone-label: 4px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  width: 100%;
}

* {
  box-sizing: border-box;
}

.#{$prefix}fileupload {
  &__wrapper {
    display: block;
    overflow: hidden;
    border-radius: $file-upload-default-radius;
  }

  #_file {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    visibility: hidden;
  }

  &__progress-multiple {
    display: flex;

    @include for-size(phone) {
      margin-bottom: 32px;
      justify-content: flex-end;
      align-items: center;
    }

    &__circle {
      margin-left: 24px;
    }

    &__status {
      display: flex;
      align-items: center;
    }
  }

  &__footer {
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    padding-right: 41px;
    justify-content: space-between;

    @include for-size(phone) {
      flex-direction: column-reverse;
      padding-left: 24px;
      padding-right: 24px;
    }
  }

  &__container {
    .#{$prefix}fileupload__preview {
      visibility: hidden;
      display: none;
    }

    &--has-file {
      .#{$prefix}fileupload__select {
        visibility: hidden;
        display: none;
      }

      .#{$prefix}fileupload__preview {
        visibility: visible;
        display: block;
      }
    }
  }

  &__dropzone {
    padding: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: v(dropzoneBackground);
    border: 1px dashed v(dropzoneBorderSingle);
    height: 90px;
    cursor: pointer;
    border-radius: $file-upload-default-radius;
    box-sizing: border-box;

    &__label {
      margin-left: $file-upload-dropzone-label;
    }

    &--has-error {
      border: 1px dashed v(errorMessageColor) !important;
    }

    &--drag-over {
      border: 3px dashed v(dropzoneDragOverBorder);
      outline: none;
      background: v(dropzoneDragOverBackground);

      > envc-eon-ui-icon,
      > envc-eon-ui-text,
      > envc-eon-ui-link {
        transform: translateX(-2px);
      }
    }

    &__icon {
      margin-right: 28px;
    }

    envc-eon-ui-icon {
      --color: var(--dropzoneIconColor);
    }

    envc-eon-ui-text {
      --color: var(--dropzoneContentColor);
    }

    envc-eon-ui-link {
      --contentColor: var(--dropzoneLinkColor) !important;
      --contentHoverColor: var(--dropzoneLinkColor) !important;
      --contentFocusColor: var(--dropzoneLinkColor) !important;
    }

    &:hover:not(.#{$prefix}disabled) {
      border: 3px dashed v(dropzoneHoverBorder);
      background: v(dropzoneHoverBackground);

      > envc-eon-ui-icon,
      > envc-eon-ui-text,
      > envc-eon-ui-link {
        transform: translateX(-2px);
      }
    }

    // ENVIAM: focus -> focus-visible
    &:focus-visible:not(.#{$prefix}disabled) {
      outline-style: solid;
      outline-width: 3px;
      // ENVIAM: change color variable
      outline-color: v(dropzoneFocusBorder);
      outline-offset: 3px;
      border: 1px dashed v(dropzoneBorderSingle);

      > envc-eon-ui-icon,
      > envc-eon-ui-text,
      > envc-eon-ui-link {
        transform: translateX(0);
      }
    }

    &.#{$prefix}disabled {
      cursor: not-allowed;

      &:focus,
      &:focus-visible,
      &:hover {
        outline: none;
      }

      > * {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }

  &__select {
    @include for-size(phone) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__preview-wrapper {
    position: relative;

    @include for-size(phone) {
      padding: 0;
    }

    &__list {
      display: grid;
      row-gap: 8px;
      max-height: 365px;
      overflow: auto;
    }

    .#{$prefix}fileupload__dropzone {
      padding: 0;
      display: none;
      visibility: hidden;
      width: 100%;
      height: 100%;
      background: none;
      border: none;
      cursor: default;
    }

    &--has-file {
      .#{$prefix}fileupload__dropzone {
        display: block;
        visibility: visible;
        border: none;
        outline: none;

        &:hover {
          border: none;
          outline: none;
          background: none;
        }
      }
    }
  }

  &__button-wrapper {
    display: grid;
    grid-template-columns: auto auto auto;
    column-gap: 16px;

    @include for-size(phone) {
      width: 100%;
      grid-template-columns: 100%;
      row-gap: 16px;
    }
  }

  &__icon {
    margin-bottom: 26px;
  }

  &__browse {
    margin-top: 32px;
  }

  &__upload-complete {
    background: v(uploadCompleteBackground);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90px;
    border-radius: $file-upload-default-radius;

    @include for-size(phone) {
      height: 160px;
      margin-left: 24px;
      margin-right: 24px;
    }

    &__status {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 14px;

      &__text {
        display: flex;
        align-items: center;
      }
    }
  }
}
